import { cx } from "@emotion/css";
import type { FC, PropsWithChildren } from "react";

import ReturnIcon from "@/assets/arrow-right-600.svg?react";

const Header: FC<
  PropsWithChildren & {
    canBack?: boolean;
    backText?: string;
    onClick?: () => void;
  }
> = ({ children, canBack = false, backText = "戻る", onClick }) => {
  return (
    <div
      className={cx(
        "relative h-14",
        "flex items-center justify-between",
        "z-10 bg-white shadow-card"
      )}
    >
      {canBack && (
        <div
          className="absolute left-0 top-0 flex h-full cursor-pointer items-center gap-0.5 pl-4 text-[16px] font-semibold leading-none"
          onClick={onClick}
        >
          <ReturnIcon className="h-4 w-4 shrink-0" aria-hidden />
          <span>{backText}</span>
        </div>
      )}
      <span></span>
      <span className={cx("text-center text-lg font-semibold text-text-black")}>
        {children}
      </span>
      <span></span>
    </div>
  );
};

export default Header;
